import { render, staticRenderFns } from "./search.component.vue?vue&type=template&id=265c1f5d&scoped=true&"
import script from "./search.component.vue?vue&type=script&lang=js&"
export * from "./search.component.vue?vue&type=script&lang=js&"
import style0 from "./search.component.vue?vue&type=style&index=0&id=265c1f5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265c1f5d",
  null
  
)

export default component.exports